import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { IBankBranch } from '../../models/IEnums.model';
import { baseUrl } from '../../utils/baseUrl';

function ChequeBookModal(props:any) {

    const [pricePerChequeBook, setPricePerChequeBook] = useState(1500)
    const [noOfChequeBook, setNoOfChequeBook] = useState(1)
    const [bankBranches, setBankBranches] = useState<IBankBranch[]>([])

    const getBankBranches = () => {
        axios.get(`${baseUrl}Enum/BranchCodeList`)
            .then((response) => {
                setBankBranches(response.data)
            })
            .catch((err) => {
            })
    }

    const handleNoOfChequeBooks = (event:any) => {
        setNoOfChequeBook(event.target.value)
    }

    const submitChequeBookData = () => {
        ('submit data')
    }

    useEffect(() => {
        getBankBranches()
    },[])

    return (
        <div>
            <div className="container">
            <h5 className="text-center mod-title mt-5 mb-3" id=""><b>Cheque request details</b></h5>

            <div className="row mb-3">
              <div className="col-sm-8">
                <div className="form-row mb-3">
                      <label htmlFor="phonenumber" className="label_text5">Select quantity</label>
                  <div className="mr-2 d-flex">
                    <div>
                      <input type="text" className="form-control bg-white mb-0 input-leaves" placeholder="50 leaves"
                        disabled/>
                      <small className="small-text"><span className="font-weight-bold"><b>₦{pricePerChequeBook}</b></span> per chequebook</small>
                    </div>
                    <div>
                        <select onChange={handleNoOfChequeBooks} style={{height:'40px', width: '50px', marginLeft:'-10px', borderRadius: '3px'}}>
                            {[1,2,3,4,5].map((item) => {
                                return (<option value={item} key={item}>{item}</option>)
                            })}
                        </select>
                    </div>
                  </div>

                </div>
              </div>
              <div className="col-sm-4">
                <div className="amount text-danger font-weight-bold pl-4 mt-4">
                  <p className="pt-2" style={{paddingLeft:'10px'}}><b>₦{pricePerChequeBook * noOfChequeBook}</b></p>
                </div>
              </div>
            </div>
            <div className="mb-4">
              <label htmlFor="phonenumber" className="label_text5 mb-3">Select mode of delivery</label>
              <div className="pickup text-center">
                <p className="pt-3 mr-3">Branch pickup</p><span style={{color:'#fff', backgroundColor:'#dc3545', marginLeft:'10px'}} className="badge badge-danger">Free</span>
              </div>

            </div>
            <div className="">
              <label htmlFor="phonenumber" className="label_text5 mb-3">Would you be kind enough to choose a branch of your
                choice
                for the cheque collection?</label>
            </div>

            <div className=" row form-group d-flex  ">
              <div className="col-lg-6 mr-n3">
                <label htmlFor="employment" className="label_text">State</label>
                <select className="form-control border-dark bg-white" name="branch" id="">
                  <option value="yes" className="">Select state</option>
                </select>
              </div>
              <div className="col-lg-6">
                <label htmlFor="occupation" className="label_text">Branch</label>
                <select className="form-control border-dark bg-white" name="branch" id="">
                  <option value="" className="">Select branch</option>
                    {bankBranches.map((branch: IBankBranch) => {
                        return (
                            <option key={branch.id} value={branch.id}>{branch.branch}</option>
                        )
                    })}
                </select>
              </div>
            </div>
            <label htmlFor="phonenumber" className="label_text5 mb-3">Total cost</label>
            <div className="cheque-cost mt-n3">
              <div className="container pt-2">
                <div className="d-flex justify-content-between label_text5 mb-0 mt-2">
                  <p>Chequebook * {noOfChequeBook}</p>
                  <p className="">₦{pricePerChequeBook * noOfChequeBook}</p>
                </div>
                <div className="d-flex justify-content-between label_text5 mb-0">
                  <p>VAT charge 7.5%</p>
                  <p className="">₦{(pricePerChequeBook * noOfChequeBook) * 0.075}</p>
                </div>
                <div className="d-flex justify-content-between label_text5 mb-2">
                  <p>Branch pickup</p>
                  <p className="">Free</p>
                </div>
                <div className="d-flex justify-content-between label_text5">
                  <p className=" font-weight-bold "><b>Total</b></p>
                  <p className="font-weight-bolder"><b>₦{(pricePerChequeBook * noOfChequeBook) + (pricePerChequeBook * noOfChequeBook) * 0.075}</b></p>
                </div>
              </div>
            </div>
            <div className=" row d-flex float-right mt-2 mr-1">
              <div className="col-lg-6 mb-3">
                <button className="btn btn-outline-danger mr-3 btn-filled-white" data-bs-dismiss="modal"
                  >Cancel
                </button>
              </div>
              <div className="col-lg-6">
                <button type="submit" className="btn btn-danger btn-filled-red" data-bs-dismiss="modal"
                    onClick={submitChequeBookData}
                  >Submit
                </button>
              </div>
            </div>

          </div>
        </div>
    );
}

export default ChequeBookModal;